document.querySelectorAll(".section-text-slider .swiper").forEach((slider) => {
    new Swiper(slider, {
        slidesPerView: 1,
        speed: 800,
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});
